import {Injectable, EventEmitter} from '@angular/core';
import {HttpApiService} from "./http-api.service";
import {EndpointsService} from "./endpoints.service";
import {Constants} from "./constants";
import {SharedService} from "./shared.service";
import {Router} from "@angular/router";

@Injectable()
export class UserService {
  private loggedIn = false;
  private role: string = "";
  private user: any;
  private loggedOutEvent = new EventEmitter();
  private loggedInEvent = new EventEmitter();
  private testKey = "janaydiajaye";
  commerceNavEvent: EventEmitter<any> = new EventEmitter();
  myAccountEvent: EventEmitter<any> = new EventEmitter();
  constructor(private Api: HttpApiService,
              private sharedService: SharedService,
              private router: Router,
              private endpoints: EndpointsService) {
    this.loggedIn = !!this.getAccessToken();
    this.role = localStorage.getItem("role");
    if (this.isLoggedIn()) {
      this.getCurrentUser()
        .then(user => {
          console.log("current user loaded");
        });
    }
  }

  login(username, password) {
    let self = this;
    return new Promise((resolve) => {
      self.Api.post(self.endpoints.getLoginUrl(), {
        username: username,
        password: password,
        tenantDomain: Constants.TENANT_ID()
      }).subscribe((res: any) => {
          if (res.access_token) {
            self.role = res.roles[0];
            self.setAccessToken(res.access_token, self.role);
            self.loggedIn = true;
            self.getCurrentUser()
              .then(user => {
                console.log("current user loaded");
                self.loggedInEvent.emit(user);
              });
          }
          resolve(res);
        },
        error => {
          resolve({status: "error", message: error._body})
        });

    });
  }

  logout(shouldRedirect: boolean = true) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('redirectUrl');
    localStorage.removeItem("role");
    this.sharedService.setParameter("selectedProfile", null);
    this.sharedService.setParameter("selectedPricingPlan", null);
    this.sharedService.setParameter("selectedRFQ", null);
    this.loggedIn = false;
    if (shouldRedirect)
      window.location.href = window.location.origin + "/login"
      // this.router.navigateByUrl("/login");
    this.user=null;
    this.loggedOutEvent.emit("user logged out");
  }

  handleLoggedOutEvent() {
    return this.loggedOutEvent;
  }

  handleLoggedInEvent() {
    return this.loggedInEvent;
  }

  public getCurrentUser(isUpdating: boolean = false) {
    const self = this;
    return new Promise((resolve) => {
      if (!self.isLoggedIn()) {
        resolve(null);
      }
      if (!isUpdating && self.user) {
        resolve(self.user);
      } else {
        self.Api.get(this.endpoints.getCurrentUserUrl(), true)
          .subscribe(user => {
              self.user = user;
              resolve(self.user);
            },
            error => {
              // console.log(error);
            });
      }
    });
  };

  setCurrentUser(user) {
    this.user = user;
  }

  isLoggedIn() {
    return this.loggedIn
  }

  private setAccessToken(token: string, role: string) {
    let now: number = new Date().getTime();
    localStorage.setItem('access_tokenTime', now.toString());
    localStorage.setItem('access_token', token);
    localStorage.setItem('role', role);
  }

  getAccessToken() {
    let now: number = new Date().getTime();
    let setupTime: number = +localStorage.getItem('access_tokenTime');
    if (setupTime) {
      if (now - setupTime > 60 * 60 * 1000) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('access_tokenTime');
      }
    }
    this.role = localStorage.getItem("role");
    return localStorage.getItem('access_token');
  }

  signUp(data: any, role: string, loggedIn: boolean) {
    this.filterDomain(data);
    data.redirectTo = Constants.ORIGIN() + "/login";
    return this.Api.post(this.endpoints.getSignUpUrl() + "?role=" + role + "&tenant=" + Constants.TENANT_ID(), data, loggedIn);
  }

  filterDomain(user) {
    let value = user.domain;
    if(!value) {
      return;
    }

    value = value.replace(/\/$/, "");
    value = value.replace("https://", "");
    value = value.replace("http://", "");
    value = value.replace("www.", "");
    user.domain = value.toLowerCase();
  }

  activate(verificationCode: string) {
    return this.Api.post(this.endpoints.getUserActivateUrl() + "?id=" + verificationCode, {});
  }

  isSuperAdmin() {
    return this.role == "ROLE_SUPER_ADMIN";
  }

  isReseller() {
    return this.role == "ROLE_TENANT_ADMIN";
  }

  isVendor() {
    return this.role == "ROLE_APP_VENDOR";
  }

  isBuyer() {
    return this.role == "ROLE_USER";
  }

  sendPartialSignUpDataToServer(data: any, role, tabClose: boolean = false) {
    let hasData: boolean = false;
    if (data.email || data.skypeId || data.username || data.title ||
      data.phoneNumber || data.firstName || data.lastName || data.companyName ||
      data.domain || data.howFindUs || (data.address && (data.address.addressLine1 || data.address.city))) {
      hasData = true;
    }
    if (hasData) {
      if (tabClose) {
        let xhr = new XMLHttpRequest();
        xhr.open("POST", this.endpoints.getInProgressSignUpUrl() + "?role=" + role, false);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(data));
      } else {
        this.Api.post(this.endpoints.getInProgressSignUpUrl() + "?role=" + role, data)
          .subscribe(res => {

          });
      }
    }
  }

  getDataFromIPGeo() {
    return new Promise((resolve) => {
      this.Api.get(this.endpoints.getIPAddressUrl(), false)
        .subscribe(res => {
            this.Api.get(Constants.IP_GEO_LOCATION_URL(), false)
              .subscribe(country => {
                  resolve(country);
                },
                error => {
                  // console.log(error);
                });
          },
          error => {
            console.log('Error:' + error);
            return false;
          });

    });
  }

  handleCommerceNavEvent() {
    return this.commerceNavEvent;
  }
  emitCommerceNavEvent() {
    this.commerceNavEvent.emit();
  }

  handleMyAccountEvent() {
    return this.myAccountEvent;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts